'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const React = require('react');
const components_navigation_PageNavigation_NestedFirstRow = require('./NestedFirstRow.cjs.js');
const components_navigation_PageNavigation_NonNestedRow = require('./NonNestedRow.cjs.js');
const components_navigation_PageNavigation_PageNavigationContext = require('./PageNavigationContext.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_navigation_Link_Link = require('../Link/Link.cjs.js');

const Styles = {
  list: react.css`
    cursor: pointer;
    list-style: none;
    padding: 0;
    margin: 0;
  `,
  title: react.css`
    margin-bottom: var(--zds-space-12);
    margin-left: var(--zds-space-8);
  `,
  expandAllButton: react.css`
    margin-bottom: var(--zds-space-12);
    margin-left: var(--zds-space-8);
    ${theme_Typography.Typography.SmallPrint2}
  `
};
const getInitialExpansionStateLookupTable = (items) => {
  const lookupTable = {};
  for (const item of items) {
    lookupTable[item.id] = item.initiallyExpanded || false;
  }
  return lookupTable;
};
function PageNavigation({ initiallySelected, items, nested, onSelect, showExpandAllButton = false, title }) {
  const [id, setId] = React.useState(initiallySelected || "");
  const [isAllExpanded, setIsAllExpanded] = React.useState(false);
  const [expansionStateLookupTable, setExpansionStateLookupTable] = React.useState(getInitialExpansionStateLookupTable(items));
  const isExpanded = (rowId) => {
    return expansionStateLookupTable[rowId] || false;
  };
  const toggleExpand = (rowId) => {
    setExpansionStateLookupTable((lookupTable) => {
      return Object.assign(Object.assign({}, lookupTable), { [rowId]: !lookupTable[rowId] });
    });
  };
  const expandAll = () => {
    setExpansionStateLookupTable((lookupTable) => {
      const newLookupTable = Object.assign({}, lookupTable);
      for (const item in newLookupTable) {
        newLookupTable[item] = !isAllExpanded;
      }
      setIsAllExpanded((allExpanded) => !allExpanded);
      return newLookupTable;
    });
  };
  if (!items) {
    return null;
  }
  const showCount = items.some((item) => (item.count || 0) > 0);
  return react.jsx(
    components_navigation_PageNavigation_PageNavigationContext.Provider,
    { value: { id, setId, toggleExpand } },
    nested && showExpandAllButton && react.jsx(
      "div",
      { onClick: expandAll, onKeyPress: expandAll, "data-testid": "pagenavigation-expandall-button", role: "button", tabIndex: 0, css: Styles.expandAllButton, "data-zds": true },
      react.jsx(components_navigation_Link_Link.Link, null, isAllExpanded ? "Collapse all" : "Expand all")
    ),
    title && react.jsx(
      "div",
      { css: Styles.title, "data-zds": true },
      react.jsx(components_display_Text_Text.Text, { tag: "p", type: "ParagraphHeader3" }, title)
    ),
    react.jsx("ul", { css: Styles.list, "data-zds": true }, nested ? items.map((item) => react.jsx(components_navigation_PageNavigation_NestedFirstRow, { item, key: item.id, isExpanded: isExpanded(item.id), onSelect })) : items.map((item) => react.jsx(components_navigation_PageNavigation_NonNestedRow, { item, key: item.id, onSelect, showCount })))
  );
}

exports.PageNavigation = PageNavigation;
//# sourceMappingURL=PageNavigation.cjs.js.map
